import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

function calcDigit(digits: string, length: number): number {
  let sum = 0;
  for (let i = 0; i < length; i++) {
    sum += parseInt(digits[i], 10) * (length + 1 - i);
  }
  const rem = (sum * 10) % 11;
  return rem >= 10 ? 0 : rem;
}

export function validateCpf(value: string): boolean {
  const cpf = value.replace(/\D/g, '');
  if (cpf.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(cpf)) return false;
  if (calcDigit(cpf, 9) !== parseInt(cpf[9], 10)) return false;
  if (calcDigit(cpf, 10) !== parseInt(cpf[10], 10)) return false;
  return true;
}

export const cpfValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value as string;
  if (!value) return null;
  return validateCpf(value) ? null : { invalidDocument: true };
};
